<template>
  <div class="home">
    <div class="header">
      <!-- <div class="el-icon-arrow-left iconi"></div> -->
      <div>瑞文标准智商IQ测试-专业版</div>
    </div>

    <div class="jj">
      <div class="jjTop">瑞文标准智商IQ测试-专业版</div>
      <div class="jjbottom">
        瑞文智力测验一共有60张图组成，由5个单元的渐进矩阵构图组成，每个单元在智慧活动的要求上各不相同；每个题目都有一定的主题，
        但是每张大图都缺少一部分。选其中一张小图填补在大图的空缺部分，使整个大图合理、完整。【测试完毕请你选择准确的年龄】
      </div>
    </div>

    <div class="zb">
      <div class="btbt">测评指标</div>
      <div class="zbItem">
        <span>测评维度</span>
        <span>5大维度</span>
      </div>
      <div class="zbItem">
        <span>测评题目</span>
        <span>60个精选题目</span>
      </div>
      <div class="zbItem">
        <span>预计用时</span>
        <span>20分钟</span>
      </div>
    </div>

    <div class="goBtn" @click="gotocp">开始测评</div>

    <div class="xzxz">
      <div class="yuan" @click="isxz = !isxz">
        <img v-if="isxz" src="@/assets/wxz.png" alt="" />
        <img v-else src="@/assets/xz.png" alt="" />
      </div>
      <span style="font-size: 14px"
        >阅读并确认
        <a
          href="https://bu.other.sanwubeixin.cn/wap/agreement?w=11d867796d85db8cad5280ac44cec7c1"
          >《隐私协议》</a
        >
      </span>
    </div>
    <!-- 开关关闭的 -->
    <div
      class="gsMessage"
      v-if="isconfigforChannel?.ability?.used?.func?.domain_name_change != 1"
    >
      <div style="margin-bottom: 30px">
        关于我们：专业的测评服务提供平台。我们的理念是“自察即成长”，旨在为更多人的成长提供专业指导。内容涵盖性格、情绪情感、职场发展、人际关系等。参照专业量表进行本地化修订，以轻松有趣的方式帮助用户对自己的状况进行评估，深受用户的欢迎。
      </div>

      <!-- <div
        class="rItem"
        v-if="
          isconfigforChannel?.ability?.used.comm.is_active == '1' &&
          isconfigforChannel?.ability?.used.func.online_service_info !== '' &&
          isconfigforChannel?.ability?.used.func.online_service_info !== '0'
        "
      >
        <span
          >在线客服：<a
            :href="isconfigforChannel?.ability?.used.func.online_service_info"
            style="color: #999999; font-size: 12px"
            >点击跳转</a
          ></span
        >
        <span></span>
      </div> -->

      <div class="rItem">
        <span
          >在线客服：<a
            href="https://chatbot.aliyuncs.com/intl/index.htm?locale=zh-CN&from=MXphHSHvOY"
            style="color: #999999; font-size: 12px"
            >点击跳转</a
          ></span
        >
        <span></span>
      </div>

      <div
        class="rItem"
        v-if="
          isconfigforChannel?.ability?.used.comm.is_active == '1' &&
          isconfigforChannel?.ability?.used.func.customer_serv !== '' &&
          isconfigforChannel?.ability?.used.func.customer_serv !== '0'
        "
      >
        <span
          >电话：{{
            isconfigforChannel?.ability?.used.func.customer_serv
          }}</span
        >
        <span></span>
      </div>
      <!-- <div
        class="rItem"
        v-if="
          isconfigforChannel?.ability?.used.comm.is_active == '1' &&
          isconfigforChannel?.ability?.used.func.corporation !== '' &&
          isconfigforChannel?.ability?.used.func.corporation !== '0'
        "
      >
        <span
          >公司：{{ isconfigforChannel?.ability?.used.func.corporation }}</span
        >
        <span></span>
      </div> -->
      <div class="rItem">
        <span> 公司：成都吉特拓思网络科技有限公司 </span>
        <span></span>
      </div>
      <!-- <div
        class="rItem"
        v-if="
          isconfigforChannel?.ability?.used.comm.is_active == '1' &&
          isconfigforChannel?.ability?.used.func.location !== '' &&
          isconfigforChannel?.ability?.used.func.location !== '0'
        "
      >
        <span>地址：{{ isconfigforChannel?.ability?.used.func.location }}</span>
        <span></span>
      </div> -->

      <div class="rItem">
        <span
          >地址：中国（四川）自由贸易试验区成都市天府新区兴隆街道集萃街619号天府海创园2-2号楼17层</span
        >
        <span></span>
      </div>

      <div class="rItem">
        <span>蜀ICP备2024111262号</span>
        <span></span>
      </div>

      <div class="addthree">
        <!-- <div
          class="rItem"
          v-if="
            isconfigforChannel?.ability?.used.comm.is_active == '1' &&
            isconfigforChannel?.ability?.used?.func.user_agreement !== '' &&
            isconfigforChannel?.ability?.used?.func.user_agreement !== '0' &&
            isconfigforChannel?.ability?.used?.func.user_agreement
          "
        >
          <span
            ><a
              :href="isconfigforChannel?.ability?.used?.func.user_agreement"
              style="color: #999999; font-size: 12px"
              >《用户协议》</a
            ></span
          >
          <span></span>
        </div>
        <div
          class="rItem"
          v-if="
            isconfigforChannel?.ability?.used.comm.is_active == '1' &&
            isconfigforChannel?.ability?.used?.func.privacy_policy !== '' &&
            isconfigforChannel?.ability?.used?.func.privacy_policy !== '0' &&
            isconfigforChannel?.ability?.used?.func.privacy_policy
          "
        >
          <span
            ><a
              :href="isconfigforChannel?.ability?.used?.func.privacy_policy"
              style="color: #999999; font-size: 12px"
              >《隐私政策》</a
            ></span
          >
          <span></span>
        </div>
        <div
          class="rItem"
          v-if="
            isconfigforChannel?.ability?.used.comm.is_active == '1' &&
            isconfigforChannel?.ability?.used?.func.refund_policy !== '' &&
            isconfigforChannel?.ability?.used?.func.refund_policy !== '0' &&
            isconfigforChannel?.ability?.used?.func.refund_policy
          "
        >
          <span
            ><a
              :href="isconfigforChannel?.ability?.used?.func.refund_policy"
              style="color: #999999; font-size: 12px"
              >《退款政策》</a
            >
          </span>
          <span></span>
        </div> -->
        <div class="rItem">
          <span
            ><a
              href="https://bu.other.sanwubeixin.cn/wap/agreement?w=8d8f733a7c2a2ea60df6439a28a2b9a3"
              style="color: #999999; font-size: 12px"
              >《用户协议》</a
            ></span
          >
          <span></span>
        </div>
        <div class="rItem">
          <span
            ><a
              href="https://bu.other.sanwubeixin.cn/wap/agreement?w=11d867796d85db8cad5280ac44cec7c1"
              style="color: #999999; font-size: 12px"
              >《隐私政策》</a
            ></span
          >
          <span></span>
        </div>
        <div class="rItem">
          <span
            ><a
              href="https://bu.other.sanwubeixin.cn/wap/agreement?w=7d62a275027741d98073d42b8f735c68"
              style="color: #999999; font-size: 12px"
              >《退款政策》</a
            >
          </span>
          <span></span>
        </div>
      </div>
    </div>

    <!-- 开关打开的的 -->
    <div
      class="gsMessage"
      v-if="isconfigforChannel?.ability?.used?.func?.domain_name_change == 1"
    >
      <div>该测试为收费测试--测试结果仅供参考</div>
      <div style="margin-bottom: 30px">
        关于我们：专业的测评服务提供平台。我们的理念是“自察即成长”，旨在为更多人的成长提供专业指导。内容涵盖性格、情绪情感、职场发展、人际关系等。参照专业量表进行本地化修订，以轻松有趣的方式帮助用户对自己的状况进行评估，深受用户的欢迎。
      </div>

      <!-- <div
        class="rItem"
        v-if="
          isnewconfig?.online_service_info &&
          isnewconfig.online_service_info != ''
        "
      >
        <span
          >在线客服：<a
            href="isnewconfig.online_service_info"
            style="color: #999999; font-size: 12px"
            >点击跳转</a
          ></span
        >
        <span></span>
      </div> -->

      <div class="rItem">
        <span
          >在线客服：<a
            href="https://chatbot.aliyuncs.com/intl/index.htm?locale=zh-CN&from=MXphHSHvOY"
            style="color: #999999; font-size: 12px"
            >点击跳转</a
          ></span
        >
        <span></span>
      </div>

      <div
        class="rItem"
        v-if="
          isnewconfig?.customer_serv &&
          isnewconfig.customer_serv != '' &&
          isnewconfig.customer_serv != '0'
        "
      >
        <span>电话：{{ isnewconfig?.customer_serv }}</span>
        <span></span>
      </div>
      <!-- <div
        class="rItem"
        v-if="
          isnewconfig?.corporation &&
          isnewconfig.corporation !== '' &&
          isnewconfig.corporation !== '0'
        "
      >
        <span>公司：{{ isnewconfig.corporation }}</span>
        <span></span>
      </div> -->
      <div class="rItem">
        <span> 公司：成都吉特拓思网络科技有限公司 </span>
        <span></span>
      </div>
      <!-- <div
        class="rItem"
        v-if="
          isnewconfig?.location &&
          isnewconfig.location !== '' &&
          isnewconfig.location !== '0'
        "
      >
        <span>地址：{{ isnewconfig.location }}</span>
        <span></span>
      </div> -->

      <div class="rItem">
        <span
          >地址：中国（四川）自由贸易试验区成都市天府新区兴隆街道集萃街619号天府海创园2-2号楼17层</span
        >
        <span></span>
      </div>

      <div class="rItem">
        <span>蜀ICP备2024111262号</span>
        <span></span>
      </div>

      <div class="addthree">
        <!-- <div
          class="rItem"
          v-if="
            isconfigforChannel?.ability?.used.comm.is_active == '1' &&
            isconfigforChannel?.ability?.used?.func.user_agreement !== '' &&
            isconfigforChannel?.ability?.used?.func.user_agreement !== '0' &&
            isconfigforChannel?.ability?.used?.func.user_agreement
          "
        >
          <span
            ><a
              :href="isconfigforChannel?.ability?.used?.func.user_agreement"
              style="color: #999999; font-size: 12px"
              >《用户协议》</a
            ></span
          >
          <span></span>
        </div>
        <div
          class="rItem"
          v-if="
            isconfigforChannel?.ability?.used.comm.is_active == '1' &&
            isconfigforChannel?.ability?.used?.func.privacy_policy !== '' &&
            isconfigforChannel?.ability?.used?.func.privacy_policy !== '0' &&
            isconfigforChannel?.ability?.used?.func.privacy_policy
          "
        >
          <span
            ><a
              :href="isconfigforChannel?.ability?.used?.func.privacy_policy"
              style="color: #999999; font-size: 12px"
              >《隐私政策》</a
            ></span
          >
          <span></span>
        </div>
        <div
          class="rItem"
          v-if="
            isconfigforChannel?.ability?.used.comm.is_active == '1' &&
            isconfigforChannel?.ability?.used?.func.refund_policy !== '' &&
            isconfigforChannel?.ability?.used?.func.refund_policy !== '0' &&
            isconfigforChannel?.ability?.used?.func.refund_policy
          "
        >
          <span
            ><a
              :href="isconfigforChannel?.ability?.used?.func.refund_policy"
              style="color: #999999; font-size: 12px"
              >《退款政策》</a
            >
          </span>
          <span></span>
        </div> -->

        <div class="rItem">
          <span
            ><a
              href="https://bu.other.sanwubeixin.cn/wap/agreement?w=8d8f733a7c2a2ea60df6439a28a2b9a3"
              style="color: #999999; font-size: 12px"
              >《用户协议》</a
            ></span
          >
          <span></span>
        </div>
        <div class="rItem">
          <span
            ><a
              href="https://bu.other.sanwubeixin.cn/wap/agreement?w=11d867796d85db8cad5280ac44cec7c1"
              style="color: #999999; font-size: 12px"
              >《隐私政策》</a
            ></span
          >
          <span></span>
        </div>
        <div class="rItem">
          <span
            ><a
              href="https://bu.other.sanwubeixin.cn/wap/agreement?w=7d62a275027741d98073d42b8f735c68"
              style="color: #999999; font-size: 12px"
              >《退款政策》</a
            >
          </span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { bingApi } from "@/api/login";
import assist from "@/utils/commonality";
// import { mapGetters } from 'vuex'
export default {
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      isxz: true,
    };
  },
  computed: {
    // ...mapGetters(['isconfigforChannel'])
    ...mapGetters(["isconfigforChannel", "isnewconfig"]),
  },
  watch: {},
  created() {
    this.getUidfunction();
  },
  async mounted() {
    this.$store.dispatch("getconfigforChannel");
    console.log(this.isconfigforChannel);

    console.log(assist.getRequest("e"));
    //e

    (function (w, d, t, r, u) {
      //必应
      var f, n, i;
      (w[u] = w[u] || []),
        (f = function () {
          //根据渠道id做判断获取 ti
          // var o = { ti: "34313204", enableAutoSpaTracking: true };
          var o = { ti: assist.getRequest("e"), enableAutoSpaTracking: true };
          (o.q = w[u]), (w[u] = new UET(o)), w[u].push("pageLoad");
        }),
        (n = d.createElement(t)),
        (n.src = r),
        (n.async = 1),
        (n.onload = n.onreadystatechange =
          function () {
            var s = this.readyState;
            (s && s !== "loaded" && s !== "complete") ||
              (f(), (n.onload = n.onreadystatechange = null));
          }),
        (i = d.getElementsByTagName(t)[0]),
        i.parentNode.insertBefore(n, i);
    })(window, document, "script", "//bat.bing.com/bat.js", "uetq");

    await bingApi();
  },
  methods: {
    gotocp() {
      assist.clearCache("paysuccess");
      assist.clearCache("answerlist");
      assist.clearCache("message");
      assist.clearCache("whichpay");
      assist.clearCache("suceesswhat");
      assist.clearCache("elapsedTime");
      assist.clearCache("startTime");
      assist.clearCache("ewmprice");
      assist.clearCache("totaltime");
      assist.clearCache("paycomplete");

      this.$router.push("/message");
    },
    async getUidfunction() {
      let res = await assist.getUid();
      assist.setCache("uid", res);
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  width: 100vw;
  max-width: 750px;
  height: 500px;
  margin: 0 auto;

  .header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    background-color: #fff;
    font-size: 18px;
    .iconi {
      font-weight: 600;
      font-size: 16px;
      position: absolute;
      left: 4%;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .jj {
    margin-top: 15px;
    width: 96%;
    margin: 15px auto 0;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .jjTop {
      background-color: #25bb74;
      display: flex;
      align-items: center;
      padding-left: 3%;
      color: #fff;
      padding: 25px;
      font-size: 18px;
    }
    .jjbottom {
      padding: 3%;
      font-size: 16px;
    }
  }

  .zb {
    margin-top: 15px;
    width: 96%;
    margin: 15px auto 0;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .btbt {
      width: 100%;
      height: 50px;
      background-color: #bdead5;
      padding: 0 20px;
      display: flex;
      align-items: center;
      font-size: 18px;
    }
    .zbItem {
      padding: 12px 20px;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .goBtn {
    width: 96%;
    margin: 15px auto 0;
    height: 50px;
    background-color: #fc4238;
    border-radius: 8px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    font-weight: 600;
    cursor: pointer;
  }
}

.gsMessage {
  margin-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgb(187, 187, 187);
  div {
    margin: 3px;
  }
}

.addthree {
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  a {
    text-decoration: none;
    white-space: nowrap;
  }
}

.xzxz {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;

  .yuan {
    cursor: pointer;

    img {
      width: 15px;
      display: block;
      margin-right: 8px;
    }
  }

  span {
    a {
      color: rgb(187, 187, 187);
    }
    color: rgb(187, 187, 187);
  }
}
</style>
